module.exports = __webpack_public_path__ + "img/case21-jpg.abc07928.jpg";